import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DownloadButton } from '@/components/buttons';
import { DocumentSection } from '@/sections/documents/DocumentSection';
import { useRouter } from 'next/router';
import { FILES } from '@/constants/files';
import { Text } from '@/components/typography';
export function InsuranceConditions(props) {
  const $ = _c(85);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["deprecatedInsuranceToS"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    locale
  } = useRouter();
  let t1;
  if ($[1] !== t) {
    t1 = t("insurance.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("insurance.sections.1.title");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t2}</h3>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("insurance.sections.1.list", {
      returnObjects: true
    }).map(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <ul className="list-disc space-y-3 pl-5 marker:text-blue-500">{t4}</ul>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("insurance.sections.2.title");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t7}</h3>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("insurance.sections.2.list", {
      returnObjects: true
    }).map(_temp2);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <ul className="list-disc space-y-3 pl-5 marker:text-blue-500">{t9}</ul>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <div>{t8}{t10}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("insurance.sections.3.title");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12) {
    t13 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t12}</h3>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("insurance.sections.3.text", {
      returnObjects: true
    }).map(_temp3);
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <div>{t13}{t14}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("insurance.sections.4.title");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <h3 className="mb-6 text-base font-bold lg:text-2xl">{t16}</h3>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("insurance.sections.4.list", {
      returnObjects: true
    }).map(_temp4);
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t18) {
    t19 = <ul className="list-disc space-y-3 pl-5 marker:text-blue-500">{t18}</ul>;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t17 || $[43] !== t19) {
    t20 = <div>{t17}{t19}</div>;
    $[42] = t17;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== locale) {
    t21 = FILES(locale);
    $[45] = locale;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  const t22 = t21.deprecatedInsurance.insurance.conditions;
  let t23;
  if ($[47] !== t) {
    t23 = t("documentTypes.insuranceConditions");
    $[47] = t;
    $[48] = t23;
  } else {
    t23 = $[48];
  }
  let t24;
  if ($[49] !== t21.deprecatedInsurance.insurance.conditions || $[50] !== t23) {
    t24 = <DownloadButton to={t22} testId="deprecatedInsuranceToSInsuranceInsuranceConditions" analyticsParam="deprecatedInsuranceToSInsuranceInsuranceConditions" className="self-start">{t23}</DownloadButton>;
    $[49] = t21.deprecatedInsurance.insurance.conditions;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== locale) {
    t25 = FILES(locale);
    $[52] = locale;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  const t26 = t25.deprecatedInsurance.insurance.ipid;
  let t27;
  if ($[54] !== t) {
    t27 = t("documentTypes.ipid");
    $[54] = t;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t25.deprecatedInsurance.insurance.ipid || $[57] !== t27) {
    t28 = <DownloadButton to={t26} testId="deprecatedInsuranceToSInsuranceIPID" analyticsParam="deprecatedInsuranceToSInsuranceIPID" className="self-start">{t27}</DownloadButton>;
    $[56] = t25.deprecatedInsurance.insurance.ipid;
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== locale) {
    t29 = FILES(locale);
    $[59] = locale;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  const t30 = t29.deprecatedInsurance.insurance.infolist;
  let t31;
  if ($[61] !== t) {
    t31 = t("documentTypes.infolist");
    $[61] = t;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t29.deprecatedInsurance.insurance.infolist || $[64] !== t31) {
    t32 = <DownloadButton to={t30} testId="deprecatedInsuranceToSInsuranceInfolist" analyticsParam="deprecatedInsuranceToSInsuranceInfolist" className="self-start">{t31}</DownloadButton>;
    $[63] = t29.deprecatedInsurance.insurance.infolist;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== t) {
    t33 = t("documentTypes.memorandum");
    $[66] = t;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  let t34;
  if ($[68] !== t33) {
    t34 = <DownloadButton to="https://www.csob.cz/portal/csob/ochrana-osobnich-udaju" testId="deprecatedInsuranceToSInsuranceMemorandum" analyticsParam="deprecatedInsuranceToSInsuranceMemorandum" className="self-start">{t33}</DownloadButton>;
    $[68] = t33;
    $[69] = t34;
  } else {
    t34 = $[69];
  }
  let t35;
  if ($[70] !== t24 || $[71] !== t28 || $[72] !== t32 || $[73] !== t34) {
    t35 = <div className="flex flex-col gap-4">{t24}{t28}{t32}{t34}</div>;
    $[70] = t24;
    $[71] = t28;
    $[72] = t32;
    $[73] = t34;
    $[74] = t35;
  } else {
    t35 = $[74];
  }
  let t36;
  if ($[75] !== t11 || $[76] !== t15 || $[77] !== t20 || $[78] !== t35 || $[79] !== t6) {
    t36 = <div className="flex flex-col gap-8">{t6}{t11}{t15}{t20}{t35}</div>;
    $[75] = t11;
    $[76] = t15;
    $[77] = t20;
    $[78] = t35;
    $[79] = t6;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] !== props || $[82] !== t1 || $[83] !== t36) {
    t37 = <DocumentSection title={t1} {...props}>{t36}</DocumentSection>;
    $[81] = props;
    $[82] = t1;
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  return t37;
}
function _temp4(item_2) {
  return <li key={item_2}>{item_2}</li>;
}
function _temp3(item_1) {
  return <Text variant="p3" className="mb-4" key={item_1}><Trans components={{
      strong: <strong />,
      br: <br />
    }}>{item_1}</Trans></Text>;
}
function _temp2(item_0) {
  return <li key={item_0}>{item_0}</li>;
}
function _temp(item) {
  return <li key={item}>{item}</li>;
}